import { toast } from 'sonner';

import type { TaskClipboardCopyOptions, TaskUtils } from './types';

export function copyToClipboard(value: string, options?: TaskClipboardCopyOptions): void {
  navigator.clipboard
    .writeText(value ?? '')
    .then(() => {
      if (!options?.silent) {
        toast(options?.message ?? 'Copied to clipboard');
      }
    })
    .catch(() => {
      toast.error('Failed to copy to clipboard');
    });
}

export const clipboardUtils: TaskUtils['clipboard'] = {
  copy: (value, options) => copyToClipboard(value, options)
};
